module.exports = __webpack_public_path__ + "media/images/pic/saska/cambridge-0e3c21157cc4c0a0d67beed0b7a717c4.svg";